// Replaces Old object properties with new properties
export const updateObjectProperties = (oldObjectProperties: any, newObjectProperties: any): any => {
  return {
    ...oldObjectProperties,
    ...newObjectProperties,
  };
};
